module.exports = __webpack_public_path__ + "img/stock5.e85ce477.png";